































































































































import PageNavi from "@/common/components/atoms/PageNavi.vue";
import ModalCompletedThanksPointSend from "@/general/components/organisms/ModalCompletedThanksPointSend.vue";
import ModalSelectSendUser from "@/general/components/organisms/ModalSelectSendUser.vue";
import TheTemplateJ from "@/general/components/templates/TheTemplateJ.vue";
import JUserSelectList from "@/general/components/pages/parts/ThanksPointUserSelection/JUserSelectList.vue";
import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import modalState from "@/common/store/modules/modalState";
import commons from "@/common/store/modules/commons";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import globals from "@/general/store/modules/globals";
import { ListResponse, ThanksPointUserSelect } from "@/general/store/models";
import ThanksPointApi from "@/general/api/thanksPointApi";
import SITE_MAP from "@/general/mixins/const/custom/sitemap";
import CONST_DATA from "@/general/mixins/const/constData";
import loginInfo from "@/general/store/modules/loginInfo";
import AuthApi from "@/general/api/authApi";
import auth from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";

@Component({
  components: {
    PageNavi,
    ModalCompletedThanksPointSend,
    ModalSelectSendUser,
    TheTemplateJ,
    JUserSelectList
  }
})
export default class ThanksPointUserSelection extends Vue {
  @Prop({ type: Boolean, required: false, default: false }) ssoFlg!: boolean;
  @Prop({ type: [Boolean, Object], default: false })
  shownModalName = "";
  searchKeyword = "";
  modalCompleteData!: any;

  breadcrumb = [
    {
      text: "",
      url: SITE_MAP.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "サンクスメッセージ",
      url: SITE_MAP.THANKS_POINT,
      pageType: "lower"
    },
    {
      text: "新規サンクスメッセージ作成",
      url: "",
      pageType: "lower"
    }
  ];

  initModalSelectSendUserData!: any;

  pageNavi: Record<string, any> = {
    currentPage: 1,
    prevPageUrl: "",
    nextPageUrl: "",
    maxPage: 0,
    baseUrl: ""
  };
  totalCount = 0;
  isLoading = true;
  isSearch = false;
  filterHeading = "ユーザーID（昇順）";
  get search() {
    return this.searchKeyword;
  }
  sorted = {
    target: "user_name-asc",
    shownState: false,
    itemList: [
      {
        id: "sorted-user_name-asc",
        value: "user_name",
        label: "ユーザー名（昇順）"
      },
      {
        id: "sorted-user_name-desc",
        value: "-user_name",
        label: "ユーザー名（降順）"
      },
      {
        id: "sorted-id-asc",
        value: "using_employee_id",
        label: "ユーザーID（昇順）"
      },
      {
        id: "sorted-id-desc",
        value: "-using_employee_id",
        label: "ユーザーID（降順）"
      },
      {
        id: "sorted-group-asc",
        value: "group_name",
        label: "グループ名（昇順）"
      },
      {
        id: "sorted-group-desc",
        value: "-group_name",
        label: "グループ名（降順）"
      }
    ]
  };

  userSelectList: Record<string, any> = [];
  noResultFound = false;
  modalSelectSendUserData = false;
  ordering: string = "";

  get resultCount() {
    return this.userSelectList.length;
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }

  get closeModalState() {
    return modalState.closeModalState;
  }

  get modalName() {
    return modalState.modalName;
  }

  get currentPage() {
    return this.pageNavi.currentPage;
  }

  set currentPage(value) {
    this.pageNavi.currentPage = value;
  }

  get maxPage() {
    return this.pageNavi.maxPage;
  }

  get nextPageUrl() {
    return this.pageNavi.nextPageUrl;
  }

  get prevPageUrl() {
    return this.pageNavi.prevPageUrl;
  }

  get baseUrl() {
    return this.pageNavi.baseUrl;
  }

  get pageSize() {
    return commons?.pageSize ? commons.pageSize : 10;
  }

  get thanksFunctionEnabled() {
    return commons.thanksFunctionEnabled;
  }

  async created() {
    this.ssoFlg = loginInfo.isSso;
    if (this.thanksFunctionEnabled === false) {
      if (this.ssoFlg) {
        // SSOログイン時は行き止まりエラー画面へ
        window.location.href = "/session-time-out/";
      } else {
        LocalStorage.removeAll();
        AuthApi.getLogout();
        auth.remove();
        window.location.href = "/system-error/";
      }
      return;
    }

    await commons.setOrgPageSpecificDataFromLocalStorage();
    this.breadcrumb[1].text = this.thanksPointName2 + "メッセージ";
    this.breadcrumb[2].text = "新規" + this.thanksPointName2 + "メッセージ作成";
    await commons.setbreadcrumb(this.breadcrumb);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const pageParam = urlParams.get("page");
    const showModalParam = urlParams.get("show_modal");
    const showModal = showModalParam ? (showModalParam as string) : "";

    const search = urlParams.get("search")
      ? (urlParams.get("search") as string)
      : "";
    this.searchKeyword = search;

    const ordering = urlParams.get("ordering")
      ? (urlParams.get("ordering") as string)
      : "";
    this.ordering = ordering || "using_employee_id";

    if (showModal == "1") {
      this.shownModalName = "completedThanksPointSend";
      const value = JSON.parse(LocalStorage.getItem("sendToUserData") as any);
      this.openModalOnLoad(value);
    } else if (showModal == "2") {
      this.shownModalName = "completedThanksPointSend_noApplovalRequired";
      const value = JSON.parse(LocalStorage.getItem("sendToUserData") as any);
      this.openModalOnLoad(value);
    }

    this.currentPage = pageParam ? parseInt(pageParam) : 1;

    this.fetchData();
    modalState.changeModal(this.shownModalName);
    this.initModalData();
    setTimeout(() => {
      this.isLoading = false;
    }, 500);

    await this.fetchData()
    const pointExclusiveControl = urlParams.get("point_exclusive_control")
      ? true
      : false;
    if (pointExclusiveControl) {
      alert("ポイント利用処理中のためしばらくたってから再度、お試しください。")
    }
    this.setFilterHeading();
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async doSort($event: any) {
    this.ordering = $event;

    this.sorted.shownState = false;
    this.fetchData();

    setTimeout(() => {
      this.isLoading = false;
    }, 500);

    this.setFilterHeading();
  }

  setFilterHeading() {
    this.sorted.itemList.map((_item, _idx) => {
      this.filterHeading =
        this.ordering === _item.value ? _item.label : this.filterHeading;
    });
  }

  async doSearch($event: any) {
    this.isLoading = true;
    this.isSearch = true;
    const searchPlusCharacter = $event.replaceAll("+", "%2B");
    this.searchKeyword = searchPlusCharacter.replaceAll("#", "%23");
 
    this.currentPage = 1;

    const title = document.title;
    const newUrl = this.pageNavi.baseUrl + this.searchKeyword ? `?search=${this.searchKeyword}` : ``;
    window.history.replaceState({}, title, newUrl);

    await this.fetchData();
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
  }

  async fetchData() {
    this.userSelectList = [];
    this.totalCount = 0;
    this.noResultFound = false;
    const url =
      `${SITE_MAP.THANKS_POINT_GIVE_THANKS_POINT}?giving_type=` +
      this.thanksMessageType;

    const response: ListResponse<ThanksPointUserSelect> = await ThanksPointApi.getThanksPointUserSelection(
      this.currentPage,
      this.pageSize,
      this.searchKeyword,
      this.ordering
    );

    if (
      response?.results?.length == undefined ||
      response?.results.length == 0
    ) {
      this.noResultFound = true;
      return;
    }

    const newUserSelectList:any = [];
    response?.results?.forEach((resObj: any) => {
      newUserSelectList.push({
        groupName: resObj.group_name,
        icon: {
          large: "",
          medium: resObj?.user_image,
          original: "",
          small: ""
        },
        id: resObj.id,
        name: resObj.user_name,
        sendTo: {
          id: resObj.id,
          comment: resObj?.bio,
          icon: {
            large: "",
            medium: "",
            original: resObj?.user_image,
            small: ""
          },
          name: resObj.user_name,
          url: url
        },
        usingEmployeeId: resObj?.using_employee_id
      });
    });
    this.userSelectList = newUserSelectList;
    this.totalCount = response.count || 0;
    this.makePagination(response);
  }

  makePagination(obj: any) {
    const prevPage = this.currentPage - 1;

    if (prevPage == 0) {
      const prevPage = 1;
    }
    const nextPage = this.currentPage + 1;
    const count = obj?.count as number;
    const maxPage =
      count % this.pageSize >= 1
        ? Math.floor(count / this.pageSize) + 1
        : count / this.pageSize;

    this.pageNavi.maxPage = maxPage;
    this.pageNavi.currentPage = this.currentPage;
    this.pageNavi.baseUrl = SITE_MAP.THANKS_POINT_USER_SELECTION + "?";

    this.pageNavi.nextPageUrl = this.pageNavi.baseUrl + "page=" + nextPage + this.searchParams + this.orderingParam;

    this.pageNavi.prevPageUrl = this.pageNavi.baseUrl + "page=" + prevPage + this.searchParams + this.orderingParam;
  }

  get searchParams(){
    return this.search ? `&search=${this.search}` : ``;
  }
  
  get orderingParam(){
    return this.ordering ? `&ordering=${this.ordering}` : ``;
  }

  get resultText() {
    return this.userSelectList.length > 0
      ? `「${this.searchKeyword}」の検索結果\u2003${this.totalCount}件`
      : "ご指定の検索条件に該当するユーザーはみつかりませんでした";
  }

  initModalData() {
    this.modalSelectSendUserData = this.initModalSelectSendUserData;
  }

  openModal(value: any) {
    LocalStorage.setItem("sendToUserData", JSON.stringify(value));

    this.modalSelectSendUserData = value;
    modalState.changeModal("selectSendUser");
  }

  openModalOnLoad(value: any) {
    this.modalCompleteData = value;
    modalState.changeModal(this.shownModalName);
  }

  get thanksMessageType() {
    const pattern = auth.user?.thanks_point_pattern;
    if (pattern != null) {
      return pattern;
    } else {
      commons.getUserInfo();
      return commons.userInfo.thanks_point_pattern;;
    }
    // return auth.user?.thanks_point_pattern;
  }

  get pointGivenRange() {
    const range = auth.user?.point_giving_range;
    if (range != null) {
      return range;
    } else {
      commons.getUserInfo();
      return commons.userInfo.point_giving_range;
    }
    // return auth.user?.point_giving_range;
  }

  getUserDetails() {
    return JSON.parse(LocalStorage.getItem("userDetails") as string);
  }

  @Watch("closeModalState")
  onCloseModalState() {
    modalState.changeModal("");
  }

  get thanksPointsApprovalEnabled() {
    return auth.user?.thanks_point_approval_enabled;
  }

  get thanksPointName1() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }

  get thanksPointName2() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME2);
  }
}
